'use client';

import { atom } from 'jotai';

import { AllFlags } from '../Entities/FlagKeys.entities';

const flagsAtom = atom<AllFlags>({} as AllFlags);

export { flagsAtom };
